// Glamzy Lookbook progress, saved on the visitor's device (localStorage):
//   styled: { slug: stars }   best stars per look
//   streak: days in a row with at least one styled look, best: longest streak, last: last day played
//   trips: { slug: { looks: { uid: stars }, done } }   story trips (src/list/FashionTrips.js), kept apart
//          from "styled" so the library's "x of N looks styled" only counts library looks
//   seenLevel: the last level the player was congratulated on (components/LevelUp.js); the level
//          itself is never saved, it comes from the stars (lib/fashionLevels.js)
const KEY = "pcg_fashion";
const EMPTY = { styled: {}, trips: {}, streak: 0, best: 0, last: null };

const today = () => new Date().toLocaleDateString("en-CA"); // YYYY-MM-DD, local time
const dayBefore = (iso) => {
  const d = new Date(`${iso}T12:00:00`);
  d.setDate(d.getDate() - 1);
  return d.toLocaleDateString("en-CA");
};

export function getProgress() {
  try {
    const p = { ...EMPTY, ...JSON.parse(localStorage.getItem(KEY) || "{}") };
    // a streak only counts while it is alive (played today or yesterday)
    if (p.last && p.last !== today() && p.last !== dayBefore(today())) p.streak = 0;
    return p;
  } catch {
    return { ...EMPTY };
  }
}

// Today counts for the streak; then the progress is saved.
function playedNow(p) {
  const t = today();
  if (p.last !== t) p.streak = p.last === dayBefore(t) ? p.streak + 1 : 1;
  p.best = Math.max(p.best, p.streak);
  p.last = t;
  try { localStorage.setItem(KEY, JSON.stringify(p)); } catch {}
  return p;
}

export function completeLook(slug, stars) {
  const p = getProgress();
  p.styled = { ...p.styled, [slug]: Math.max(stars, p.styled[slug] || 0) };
  return playedNow(p);
}

// A look finished inside a story trip's game (pcg:look-complete), and the trip's ending (pcg:trip-complete)
export function completeTripLook(trip, uid, stars) {
  const p = getProgress();
  const was = p.trips[trip] || { looks: {}, done: false };
  p.trips = { ...p.trips, [trip]: { ...was, looks: { ...was.looks, [uid]: Math.max(stars, was.looks[uid] || 0) } } };
  return playedNow(p);
}

export function completeTrip(trip) {
  const p = getProgress();
  p.trips = { ...p.trips, [trip]: { looks: {}, ...p.trips[trip], done: true } };
  return playedNow(p);
}

export const playedToday = (p) => p.last === today();

// The level-up popup has been shown for this level (it shows once per level)
export function markLevelSeen(level) {
  const p = getProgress();
  p.seenLevel = level;
  try { localStorage.setItem(KEY, JSON.stringify(p)); } catch {}
  return p;
}

// The look to suggest next: this week's looks first, then the oldest look not styled yet
export function nextUnstyled(looks, p, skip) {
  return looks.find((l) => l.slug !== skip && !p.styled[l.slug]) || null;
}
